import React from "react";
import VideoModulePage from "../../components/VideoModule/VideoModulePage";

const ExpertOpinion = () => (
  <VideoModulePage
    moduleCode="expert_opinion"
    routeBase="/expert_opinion"
    title="Эксперттік пікір"
    subtitle="Мамандардың эксперттік пікірлері мен талдаулары"
    emptyText="Іздеу бойынша видеолар табылмады"
    defaultLabel="Эксперттік пікір"
  />
);

export default ExpertOpinion;
